import React from "react";
import "./phone.less";

interface IPhoneProps {
    title?: string | JSX.Element,
    children?: React.ReactNode,
}

export const YHPhone = ({
    title = "我的phone",
    children = null,
}: IPhoneProps): JSX.Element => {

    return <div className="phone-container">
        <div className="phone-top">
            <div className="phone_header">
            </div>
        </div>
        <div className="phone-body">
            <div className="phone-left"></div>
            <div className="phone-middle">
                <div className="phone-title">
                    <span>{title}</span>
                    <div className="phone-bar"></div>
                </div>
                <div className="phone-content">
                    {
                        children
                    }
                </div>
            </div>
            <div className="phone-right"></div>
        </div>
        <div className="phone-bottom">
            <div className="phone-key"></div>
        </div>
    </div>
}